import { ElementType, FC, MouseEvent } from 'react';

import { Button, ButtonProps } from '@components/base';

import useMenu from './useMenu';

export type MenuButtonProps = ButtonProps & {
  component?: ElementType<ButtonProps>;
};

export const MenuButton: FC<MenuButtonProps> = ({
  children,
  component = Button,
  onClick,
  ...rest
}) => {
  const { onOpen } = useMenu();

  const Component = component as typeof Button;

  return (
    <Component
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        onClick?.(e);
        onOpen(e);
      }}
      {...rest}
    >
      {children}
    </Component>
  );
};
